import type { ParsedUrlQuery } from "querystring"
import type { UrlObject } from "url"

import pathMap from "./pathMap"

const resolvePath = (pathname: keyof typeof pathMap, parsedUrlQuery?: ParsedUrlQuery, keepQuery = false) => {
  const query = keepQuery ? parsedUrlQuery : undefined

  const href: UrlObject = { pathname, query }

  let as: UrlObject | undefined
  if (process.env.NODE_ENV === "production") {
    const asPath = pathMap[pathname]
    if (asPath !== undefined) {
      as = { pathname: asPath, query }
    }
  }

  return { href, as }
}

export default resolvePath
